import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["type", "lang"];
import React from 'react';
import classNames from 'classnames/bind';
import { AndroidEn, AndroidRu, AppleEn, AppleRu } from "../icons";
import styles from './MarketLink.css';
var cx = classNames.bind(styles);

var getIcon = function getIcon(_ref) {
  var type = _ref.type,
      lang = _ref.lang;

  if (type === 'appstore') {
    return lang === 'ru' ? AppleRu : AppleEn;
  }

  if (type === 'googleplay') {
    return lang === 'ru' ? AndroidRu : AndroidEn;
  }

  return function () {
    return null;
  };
};

var MarketLink = function MarketLink(_ref2) {
  var type = _ref2.type,
      lang = _ref2.lang,
      rest = _objectWithoutProperties(_ref2, _excluded);

  var Icon = getIcon({
    type: type,
    lang: lang
  });
  return /*#__PURE__*/React.createElement("a", _extends({
    target: "_blank",
    rel: "nofollow noopener"
  }, rest, {
    className: cx('MarketLink')
  }), /*#__PURE__*/React.createElement(Icon, null));
};

export default MarketLink;